import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class SlaManagementService {
	private getSlaUrl = environment.baseApiUrl + 'register/sla';
	private getEndusersUrl = environment.baseApiUrl + 'register/sla/endusers';
	private postSlaUrl = environment.baseApiUrl + 'register/sla';
	private putSlaUrl = environment.baseApiUrl + 'register/sla/{id}';
	private deleteSlaUrl = environment.baseApiUrl + 'register/sla/{id}';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	postSla(data: any): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.http.post<any>(this.postSlaUrl, data, { headers: headers });
	}

	updateSla(data: any): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const putSlaUrl = this.putSlaUrl.replace('{id}', data.id);

		return this.http.put<any>(putSlaUrl, data, { headers: headers });
	}

	deleteSla(filters: any): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();
		const deleteSlaUrl = this.deleteSlaUrl.replace('{id}', filters.id);

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.delete<any>(deleteSlaUrl, { headers: headers, params: parameters });
	}

	getSla(filters: any): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<any[]>(this.getSlaUrl, { headers: headers, params: parameters });
	}

	getEndusers(): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.http.get<any[]>(this.getEndusersUrl, { headers: headers });
	}
}
